/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Insufficientcredits_Buymore2Inputs */

const zh_chat_insufficientcredits_buymore2 = /** @type {(inputs: Chat_Insufficientcredits_Buymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买积分`)
};

const en_chat_insufficientcredits_buymore2 = /** @type {(inputs: Chat_Insufficientcredits_Buymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Credits`)
};

const es_chat_insufficientcredits_buymore2 = /** @type {(inputs: Chat_Insufficientcredits_Buymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar créditos`)
};

/**
* | output |
* | --- |
* | "Buy Credits" |
*
* @param {Chat_Insufficientcredits_Buymore2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_insufficientcredits_buymore2 = /** @type {((inputs?: Chat_Insufficientcredits_Buymore2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Insufficientcredits_Buymore2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_insufficientcredits_buymore2(inputs)
	if (locale === "en") return en_chat_insufficientcredits_buymore2(inputs)
	return es_chat_insufficientcredits_buymore2(inputs)
});
export { chat_insufficientcredits_buymore2 as "chat_insufficientCredits_buyMore" }